import React from 'react';

import {Typography} from '@mui/material';

import {Grid} from 'components/basic-components';

import styles from './GroupsInfoSection.module.scss';

const AdditionalFeatures = ({additionalFeatures}) => {
  return (
    <Grid container columnSpacing="5%" rowSpacing={'10px'}>
      {(additionalFeatures || []).map(feature => {
        return (
          <Grid xxs={12} xs={6} key={feature.id}>
            <Typography className={styles.featureText}>{feature.featureName}</Typography>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default AdditionalFeatures;
